import { Badge } from "design-system/atoms/Badge"
import { Select, SelectContent, SelectItem, SelectTrigger } from "design-system/molecules/Select"
import { whatsappLanguages } from "lopermut"
import { X } from "lucide-react"
import { useFieldArray, UseFormReturn } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { WidgetConfigurationFormType } from ".."

type LanguageOptionsProps = {
  form: UseFormReturn<WidgetConfigurationFormType>
}

const languageMap = new Map(whatsappLanguages.map((e) => [e.value, e]))

export const LanguageOptions = ({ form }: LanguageOptionsProps) => {
  const { t } = useTranslation()

  const { fields, append, remove } = useFieldArray({
    control: form.control,
    name: "languages",
  })

  const onValueChange = (option: string) => {
    const selected = languageMap.get(option)

    if (selected) {
      append(selected)
    }
  }

  return (
    <div className="flex flex-wrap gap-2">
      <Select onValueChange={onValueChange}>
        <SelectTrigger className="max-w-fit">
          <span>{t("campaigns.templates.widget.config.languageOptions.select.placeholder")}</span>
        </SelectTrigger>
        <SelectContent>
          {whatsappLanguages.map((language) => (
            <SelectItem key={language.value} value={language.value}>
              {language.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <div className="flex flex-wrap gap-2">
        {fields.map((language, index) => (
          <Badge key={language.id} variant={"outline"} className="m-0 pr-0 gap-0">
            <span>{languageMap.get(language.value)?.label}</span>
            <span onClick={() => remove(index)} className="cursor-pointer p-2">
              <X size={14} />
            </span>
          </Badge>
        ))}
      </div>
    </div>
  )
}
